// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/BespokeCRMTabs/components/Checkbox.css
// module id = 1905
// module chunks = 0